import type { SessionTheme } from '@/types'

let customCssEl: HTMLStyleElement | null = null

export function applySessionTheme(theme?: SessionTheme) {
	const root = document.documentElement

	// Clear theme when leaving presentation
	if (!theme) {
		root.style.removeProperty('--font-primary')
		root.style.removeProperty('--font-secondary')
		root.style.removeProperty('--theme-color-primary-base')
		root.style.removeProperty('--theme-color-secondary-base')
		root.style.removeProperty('--theme-color-accent-base')
		root.style.removeProperty('--theme-color-background-base')

		if (customCssEl) {
			customCssEl.remove()
			customCssEl = null
		}

		return
	}

	// CSS variables
	if (theme.fontPrimary)
		root.style.setProperty('--font-primary', theme.fontPrimary)

	if (theme.fontSecondary)
		root.style.setProperty('--font-secondary', theme.fontSecondary)

	if (theme.colorPrimary)
		root.style.setProperty('--theme-color-primary-base', theme.colorPrimary)

	if (theme.colorSecondary)
		root.style.setProperty('--theme-color-secondary-base', theme.colorSecondary)

	if (theme.colorAccent)
		root.style.setProperty('--theme-color-accent-base', theme.colorAccent)

	if (theme.colorBackground)
		root.style.setProperty(
			'--theme-color-background-base',
			theme.colorBackground
		)

	// Custom CSS
	if (theme.customCss) {
		if (!customCssEl) {
			customCssEl = document.createElement('style')
			customCssEl.setAttribute('data-session-theme', 'true')
			document.head.appendChild(customCssEl)
		}

		customCssEl.textContent = theme.customCss
	} else if (customCssEl) {
		customCssEl.remove()
		customCssEl = null
	}
}
